import Udesk from 'Udesk';
import React, { FC, memo } from 'react';
import RandomFieldSelect, { typeList_common } from 'src/components/common/RandomFieldSelect';
import styled from 'styled-components';
import { FieldFoundResponse } from 'src/api/types';
import UdeskLocales from 'UdeskLocales';

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    gap: 8px;
    flex-wrap: wrap;
    max-width: ${(props) => props.maxWidth}px;
`;

interface TemplateProps {
    dataSourceList?: number[];
    value?: (FieldFoundResponse | undefined)[];
    onChange?: (value: TemplateProps['value']) => void;
    maxWidth?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { dataSourceList, value, onChange, maxWidth } = props;

    const onValueChange = (_value?: FieldFoundResponse) => {
        const newValue = dataSourceList?.map((s, idx) => {
            if (s === _value?.inspectDataSourceType) {
                return _value;
            }
            return value?.[idx];
        });
        onChange?.(newValue);
    };

    return (
        <Wrapper maxWidth={maxWidth}>
            {dataSourceList?.map((source) => {
                const _value = value?.find((v) => v?.inspectDataSourceType === source);

                return (
                    <RandomFieldSelect
                        key={source}
                        value={_value}
                        onChange={(v) =>
                            onValueChange({
                                ...v,
                                inspectDataSourceType: source,
                            })
                        }
                        sourceList={source}
                        typeList={typeList_common}
                        style={{ width: 200 }}
                        placeholder={
                            /* 请选择 */UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.components.valueSpecial1.components.randomFieldSelectList.index.pleaseSelect + Udesk.enums.inspectDataSources.getName(source) + /* 随路字段 */UdeskLocales['current'].pages.semanticIntelligence.externalInterface.detail.components.paramsList.components.valueSpecial1.components.randomFieldSelectList.index.followthepathField
                        }
                    />
                );
            })}
        </Wrapper>
    );
});

export default Template;
